import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-slider-area-quienes',
  templateUrl: './slider-area-quienes.component.html',
  styleUrls: ['./slider-area-quienes.component.css']
})
export class SliderAreaQuienesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
